/* Labelled progress bar — ported from the prototype's barRow(). */
import React from 'react';

export default function BarRow({ label, right, pct, color }) {
	return (
		<div>
			<div style={{ display: 'flex', fontSize: 13, color: 'var(--dlg-ink-soft)' }}>
				<span>{label}</span><span style={{ marginLeft: 'auto', fontWeight: 500, color: 'var(--dlg-ink)' }}>{right}</span>
			</div>
			<div style={{ height: 8, borderRadius: 999, background: 'var(--dlg-fill)', marginTop: 4 }}>
				<div style={{ width: `${pct}%`, height: 8, borderRadius: 999, background: color }} />
			</div>
		</div>
	);
}
